import store from '@/store'
import { computed, onMounted, onUnmounted } from '@vue/composition-api'

const useGlobalAccelerator = () => {
	onMounted(() => store.dispatch.opsmonitor.subscribeGlobalAccelerator())
  onUnmounted(() => store.dispatch.opsmonitor.unsubscribeGlobalAccelerator())
  const globalAccelerator = computed(() => store.state.opsmonitor.globalAccelerator)
  return {
    globalAccelerator,
    acceleratorMapping: computed(() => globalAccelerator.value.mapping)
  }
}

export default useGlobalAccelerator
